import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { fetchOffPlatformReviews, fetchOffPlatformTestimonials } from '../../util/api';

// ================ Action types ================ //

export const FETCH_DATA_REQUEST = 'app/EmbedWidgetPage/FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'app/EmbedWidgetPage/FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'app/EmbedWidgetPage/FETCH_DATA_ERROR';

// ================ Reducer ================ //

const initialState = {
  testimonials: [],
  offPlatformReviews: [],
  reviews: [],
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_DATA_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
        testimonials: payload.testimonials,
        offPlatformReviews: payload.offPlatformReviews,
        reviews: payload.reviews,
      };
    case FETCH_DATA_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchDataRequest = () => ({ type: FETCH_DATA_REQUEST });
const fetchDataSuccess = payload => ({ type: FETCH_DATA_SUCCESS, payload });
const fetchDataError = e => ({ type: FETCH_DATA_ERROR, payload: e, error: true });

// ================ Thunks ================ //

// Loads the freelancer's quotable content for the builder: public
// on-platform reviews (with authors), off-platform reviews and published
// testimonials. The same lists power the quote picker and the baked
// AggregateRating values.
export const fetchEmbedPageData = userId => (dispatch, getState, sdk) => {
  dispatch(fetchDataRequest());

  return Promise.all([
    sdk.reviews.query({
      subject_id: userId,
      state: 'public',
      include: ['author'],
      'fields.user': ['profile.displayName'],
    }),
    fetchOffPlatformReviews(userId),
    fetchOffPlatformTestimonials(userId),
  ])
    .then(([reviewsRes, offReviewsRes, testimonialsRes]) => {
      dispatch(
        fetchDataSuccess({
          reviews: denormalisedResponseEntities(reviewsRes),
          offPlatformReviews: offReviewsRes.items || [],
          testimonials: (testimonialsRes.items || []).filter(t => t.state === 'published'),
        })
      );
    })
    .catch(e => {
      dispatch(fetchDataError(storableError(e)));
    });
};
